import * as STD from '@emersya/mpa-std-lib';

import CM                                  from '@emersya/mpa-components-manager-lib';
import { InputBool, Block, Image }         from '@emersya/mpa-components-lib';
import ViewerComponent, { NS as ViewerNS } from '../../../viewer/Viewer/Viewer';
import { NS as ViewerGraphicsNS }          from '../../../viewer/Graphics/ViewerGraphics';
import { NS as PlannerWallsEditorNS }      from '../../../viewer/planner/walls/Editor/PlannerWallsEditor';
import { NS as StandingPlinth }            from '../StandingPlinth/StandingPlinth';
import * as BasketNS                               from '@emersya/mpa-basket-lib';
import { NS as StandingStorage }           from '../StandingStorage/StandingStorage';
import { NS as StandingObjectsPositioningDynamicsSetsNS }           from '../StandingObjectsPositioningDynamicsSets/StandingObjectsPositioningDynamicsSets';


export interface IStandingPartitionsHeadsComponentConfiguration extends Block.Configuration {
	text : STD.translationsManager.TranslationMapping;
	forceBackgroundColor? : string | null;
	textLeft : STD.translationsManager.TranslationMapping;
	textRight : STD.translationsManager.TranslationMapping;
};

export class StandingPartitionsHeadsComponent extends Block.Component {
	static override initialize() {
		super.initialize();
	};

	readonly plannerCategory! : ViewerComponent.ProductCategory;
	viewerNodeLeft : ViewerComponent.ProductInstance | null = null;
	viewerNodeRight : ViewerComponent.ProductInstance | null = null;
	partitionsSpace : 'vertical' | 'top' | null = null;
	partitionsPosition : 'left' | 'back' | 'back-left' | 'back-right' | 'back-back' | 'left-right' | null = null;
	partitionsWidth : number | null = null;
	isPartitionsHeads : boolean = false;

	get usedWidthOnWall() {
		return this.isPartitionsHeads ? this.partitionsWidth || 0 : 0;
	};

	get components() {
		return app.component_configuration.productsComponents.filter(x => x.type ===
			'partitionsHead');
	};

	getWDH() {
		const p = app.currentProduct;
		if (!p) {
			this.component_throwUserError('');
		}
		const dpart = p.getPart([ 'dimensions' ]);
		return {
			width :  Number.parseFloat(dpart.getPart([ 'width' ])?.reference?.value || <string> <any> 1),
			depth :  Number.parseFloat(dpart.getPart([ 'depth' ])?.reference?.value || <string> <any> 1),
			height : Number.parseFloat(dpart.getPart([ 'height' ])?.reference?.value || <string> <any> 1)
		};
	};

	getWallThickness() {
		// TODO : DEHARDCODE
		return 0.05;
	};

	async updateDisclaimer(product : string) {
		const disclaimer1SIAE = this.component_find('@:disclaimer1SIAE');
		const disclaimer2SIAE = this.component_find('@:disclaimer2SIAE');
		const disclaimerBusiness = this.component_find('@:disclaimerBusiness');
		const tutoContainer = this.component_find('@:tutoContainer');
		const disclaimerLogoSIAE = this.component_find('@:disclaimerLogoSIAE');
		const disclaimerLogoBusiness = this.component_find('@:disclaimerLogoBusiness');
		if (product === 'siae') {
			await disclaimer1SIAE.component_disable();
			await disclaimer2SIAE.component_enable();
			await disclaimerBusiness.component_disable();
			await tutoContainer.component_enable();
			await disclaimerLogoSIAE.component_enable();
			await disclaimerLogoBusiness.component_disable();
		} else if (product === 'business') {
			await disclaimer1SIAE.component_disable();
			await disclaimer2SIAE.component_disable();
			await disclaimerBusiness.component_enable();
			await tutoContainer.component_enable();
			await disclaimerLogoSIAE.component_disable();
			await disclaimerLogoBusiness.component_enable();
		} 
	}

	async updateDisclaimerSIAE() {
		const wdh = this.getWDH();
		const disclaimer1SIAE = this.component_find('@:disclaimer1SIAE');
		const disclaimer2SIAE = this.component_find('@:disclaimer2SIAE');
		if (wdh.width * wdh.depth > 24) {
			await disclaimer1SIAE.component_disable();
			await disclaimer2SIAE.component_enable();
		} else {
			await disclaimer1SIAE.component_enable();
			await disclaimer2SIAE.component_disable();
		}
	};

	private computeMatrix(side : string) {
		const wdh = this.getWDH();
		const x = wdh.width;
		const y = wdh.height;
		const z = wdh.depth;
		void y;
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available!');
		}
		const currentPartitionsHead = app.component_configuration.productsComponents.find(x => x.type ===
			'partitionsHead' &&
			x.products.includes(product.id));
		if (!currentPartitionsHead) {
			throw STD.errors.user('No current partitions head found');
		}
		const boundingBox = currentPartitionsHead.boundingBox;
		if (!boundingBox) {
			throw STD.errors.user('Missing bounding box for head partition ' + currentPartitionsHead.SKU);
		}
		this.partitionsWidth = boundingBox.width;
		if (product.id === 'siae') {
			this.partitionsWidth = 0.6;
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No part layout available');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			throw STD.errors.user('No current option in layout part');
		}
		const layoutId = layoutCurrentOption.id;
		// if (product.id === 'confort' || product.id === 'prestige') {
		// 	if (side === 'right') {
		// 		return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
		// 	}
		// 	if (layoutId === 'shape-no-wall') {
		// 		return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
		// 	} else if (layoutId === 'shape-back-left') {
		// 		return (ViewerNS.Component.mtx(
		// 			[ (x / 2), y - app.getFloorThickness(), -z / 2 - this.getWallThickness() / 2 ],
		// 			[ 1, 1, 1 ],
		// 			0
		// 		));
		// 	} else if (layoutId === 'shape-back') {
		// 		return (ViewerNS.Component.mtx(
		// 			[ (-x / 2), y - app.getFloorThickness(), -z / 2 - this.getWallThickness() / 2 ],
		// 			[ 1, 1, 1 ],
		// 			180
		// 		));
		// 	} else if (layoutId === 'shape-back-right') {
		// 		return (ViewerNS.Component.mtx(
		// 			[ (-x / 2), y - app.getFloorThickness(), -z / 2 - this.getWallThickness() / 2 ],
		// 			[ 1, 1, 1 ],
		// 			180
		// 		));
		// 	} else if (layoutId === 'shape-left-back-right') {
		// 		return (ViewerNS.Component.mtx(
		// 			[ (-x / 2) - this.getWallThickness() / 2, y - app.getFloorThickness(), z / 2 ],
		// 			[ 1, 1, 1 ],
		// 			270
		// 		));
		// 	} else {
		// 		throw STD.errors.user('Unknown layoutId');
		// 	}
		// } else 
		if (product.id === 'business') {
			if (layoutId === 'shape-no-wall') {
				return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
			} else if (layoutId === 'shape-back-left') {
				this.partitionsPosition = 'back-left';
				if (side === 'left') {
					return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 - boundingBox.width ], [ 1, 1, 1 ], 90));
				} else {
					return (ViewerNS.Component.mtx([ (x / 2) - boundingBox.width, 0, -z / 2 ], [ 1, 1, 1 ], 0));
				}
			} else if (layoutId === 'shape-back') {
				this.partitionsPosition = 'back-back';
				if (side === 'left') {
					return (ViewerNS.Component.mtx([ -(x / 2) + boundingBox.width, 0, -z / 2 ], [ 1, 1, 1 ], 0));
				} else {
					return (ViewerNS.Component.mtx([ (x / 2) - boundingBox.width, 0, -z / 2 ], [ 1, 1, 1 ], 0));
				}
			} else if (layoutId === 'shape-back-right') {
				this.partitionsPosition = 'back-right';
				if (side === 'left') {
					return (ViewerNS.Component.mtx([ -(x / 2) + boundingBox.width, 0, -z / 2 ], [ 1, 1, 1 ], 0));
				} else {
					return (ViewerNS.Component.mtx([ (x / 2), 0, z / 2 - boundingBox.width ], [ 1, 1, 1 ], 270));
				}
			} else if (layoutId === 'shape-left-back-right') {
				this.partitionsPosition = 'left-right';
				if (side === 'left') {
					return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 - boundingBox.width ], [ 1, 1, 1 ], 90));
				} else {
					return (ViewerNS.Component.mtx([ (x / 2), 0, z / 2 - boundingBox.width ], [ 1, 1, 1 ], 270));
				}
			} else {
				throw STD.errors.user('Unknown layoutId');
			}
		} else if (product.id === 'siae') {
			const surface = x * z;
			if (surface > 24) {
				if (layoutId === 'shape-no-wall') {
					return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
				} else if (layoutId === 'shape-back-left') {
					this.partitionsPosition = 'back-left';
					if (side === 'left') {
						if (z < 3.75 && surface > 30) {
							return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
						}
						return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 - 0.6 ], [ 1, 1, 1 ], 90));
					} else {
						return (ViewerNS.Component.mtx([ (x / 2) - 0.6, 0, -z / 2 ], [ 1, 1, 1 ], 0));
					}
				} else if (layoutId === 'shape-back') {
					this.partitionsPosition = 'back-back';
					if (side === 'left') {
						return (ViewerNS.Component.mtx([ -(x / 2) + 0.6, 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ (x / 2) - 0.6, 0, -z / 2 ], [ 1, 1, 1 ], 0));
					}
				} else if (layoutId === 'shape-back-right') {
					this.partitionsPosition = 'back-right';
					if (side === 'left') {
						return (ViewerNS.Component.mtx([ -(x / 2) + 0.6, 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else {
						if (z < 3.75 && surface > 30) {
							return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
						}
						return (ViewerNS.Component.mtx([ (x / 2), 0, z / 2 - 0.6 ], [ 1, 1, 1 ], 270));
					}
				} else if (layoutId === 'shape-left-back-right') {
					this.partitionsPosition = 'left-right';
					if (side === 'left') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 - 0.6 ], [ 1, 1, 1 ], 90));
					} else {
						return (ViewerNS.Component.mtx([ (x / 2), 0, z / 2 - 0.6 ], [ 1, 1, 1 ], 270));
					}
				} else {
					throw STD.errors.user('Unknown layoutId');
				}
			} else {
				if (layoutId === 'shape-no-wall') {
					return (ViewerNS.Component.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
				} else if (layoutId === 'shape-back-left') {
					this.partitionsPosition = 'back';
					if (side === 'left') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ (x / 2) - 0.6, 0, -z / 2 ], [ 1, 1, 1 ], 0));
					}
				} else if (layoutId === 'shape-back') {
					this.partitionsPosition = 'back';
					if (side === 'left') {
						return (ViewerNS.Component.mtx([ -(x / 2) + 0.6, 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-back-right') {
					this.partitionsPosition = 'back';
					if (side === 'left') {
						return (ViewerNS.Component.mtx([ -(x / 2) + 0.6, 0, -z / 2 ], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-left-back-right') {
					this.partitionsPosition = 'left';
					if (side === 'left') {
						return (ViewerNS.Component.mtx([ -(x / 2), 0, z / 2 - 0.6 ], [ 1, 1, 1 ], 90));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else {
					throw STD.errors.user('Unknown layoutId');
				}
			}

		} else {
			throw STD.errors.user('Unknown product name');
		}
	};

	computeMatricesAndUpdateInfos() {
		this.computeMatrix('left');
		this.computeMatrix('right');
	};

	async changeBackgroundColorNumberBusiness(){
		const product = app.currentProduct;
		if(!product){
			this.component_throwUserError('');
		}
		if(product.id != 'business'){
			return;
		}
		const floorPart = product.parts.find(x => x.id === 'floor');
		if(!floorPart){
			return;
		}
		const floorPartOption = floorPart.currentOption;
		if(!floorPartOption){
			return;
		}
		const floorPartOptionId = floorPartOption.id.replace('floor-', '').replace('-','_');
		await app.viewer.setMaterialsGroups({
			values : [
				{
					groupName :         'fond_custom_numero',
					configurationName : floorPartOptionId
				}
			]
		});
	};

	async insert() {
		const product = app.currentProduct;
		if (this.viewerNodeLeft || this.viewerNodeRight || !product || !app.viewer.planner) {
			this.component_throwUserError('');
		}
		if (product.id === 'confort' || product.id === 'prestige') {
			this.partitionsSpace = 'top';
			return;
		}
		const trs = {
			left :  <Record<string, string>> {
				en : 'left',
				fr : 'gauche'
			},
			right : <Record<string, string>> {
				en : 'right',
				fr : 'droite'
			}
		};
		const category = app.viewer.categories.find(x => x.name === 'partitionsHeads');
		if (!category) {
			this.component_throwLibraryError('');
		}
		const GLE = <InputBool.Component> this.component_find('@:graphic-left:header.enable');
		const GRE = <InputBool.Component> this.component_find('@:graphic-right:header.enable');
		if (app.isReloading) {
			// if(product.id === 'confort' || product.id === 'prestige'){
			// 	await GLE.component_find('@@@').component_disable();
			// 	await GRE.component_find('@@@').component_disable();
			// }else{
				if (GLE.component_find('@@@').component_isDisabled) {
					await GLE.component_find('@@@').component_enable();
				}
				if (GRE.component_find('@@@').component_isDisabled) {
					await GRE.component_find('@@@').component_enable();
				}
			// }
			await this.updateDisclaimer(product.id);
			const instances = Array.from(ViewerComponent.self.safe.value.productInstances);
			const nodeLeft = instances.find(x => x.product.category === category && x.metadata.id === 'left');
			const nodeRight = instances.find(x => x.product.category === category && x.metadata.id === 'right');
			if (!nodeLeft && !nodeRight) {
				this.isPartitionsHeads = false;
				const GL = <InputBool.Component> this.component_find('@:graphic-left');
				if (!GL.component_isDisabled) {
					await GL.component_disable();
				}
				const GR = <InputBool.Component> this.component_find('@:graphic-right');
				if (!GR.component_isDisabled) {
					await GR.component_disable();
				}
				return;
			}
			if(nodeLeft){
				this.viewerNodeLeft = nodeLeft;
				if (!app.previousConfigurationMetadata) {
					throw new Error;
				}
				// if(product.id === 'siae' || product.id === 'business'){
					const VGLeft = <ViewerGraphicsNS.Component> this.component_find('@:graphic-left');
					await VGLeft.updateValue((<any> this.viewerNodeLeft.metadata.customImages)[ 0 ]);
				// }
			}else{
				this.viewerNodeLeft = null;
			}
			if(nodeRight){
				this.viewerNodeRight = nodeRight;
				if (!app.previousConfigurationMetadata) {
					throw new Error;
				}
				const VGRight = <ViewerGraphicsNS.Component> this.component_find('@:graphic-right');
				await VGRight.updateValue((<any> this.viewerNodeRight.metadata.customImages)[ 0 ]);
			}else{
				this.viewerNodeRight = null;
			}
			this.isPartitionsHeads = true;
			// if (product.id === 'business' || product.id === 'siae') {
				this.partitionsSpace = 'vertical';
			// } else {
				// this.partitionsSpace = 'top';
			// }
			{
				const product = app.currentProduct;
				if (!product) {
					throw STD.errors.user('No current product available!');
				}
				const layoutPart = product.getPart([ 'layout' ]);
				const layoutCurrentOption = layoutPart.currentOption;
				if (layoutCurrentOption) {
					this.computeMatricesAndUpdateInfos();
				}
			}
			// if(product.id === 'confort' || product.id === 'prestige'){
			// 	await GLE.component_find('@@@').component_disable();
			// 	await GRE.component_find('@@@').component_disable();
			// }else{
				if (GLE.component_find('@@@').component_isDisabled) {
					await GLE.component_find('@@@').component_enable();
				}
				if (GRE.component_find('@@@').component_isDisabled) {
					await GRE.component_find('@@@').component_enable();
				}
			// }
			this.updateDisclaimer(product.id);
			return;
		}
		this.isPartitionsHeads = true;
		await this.updateDisclaimer(product.id);
		if (product.id === 'business' || product.id === 'siae') {
			this.partitionsSpace = 'vertical';
			const partitionHeadsProductSchemaLeft = this.plannerCategory.products.find(x => x.SKU ===
				`@partitionsHead-${ product.id }Left`);
			const partitionHeadsProductSchemaRight = this.plannerCategory.products.find(x => x.SKU ===
				`@partitionsHead-${ product.id }Right`);
			if (!partitionHeadsProductSchemaLeft || !partitionHeadsProductSchemaRight) {
				this.component_throwLibraryError('');
			}
			const hasLayoutReady = !!product.getPart([ 'layout' ])?.currentOption;
			const hasLeft = !hasLayoutReady || !this.isEqual(this.computeMatrix('left'), app.viewer.mtx([0,0,0], [0,0,0], 0));
			const hasRight = !hasLayoutReady || !this.isEqual(this.computeMatrix('right'), app.viewer.mtx([0,0,0], [0,0,0], 0));
			if (hasLeft) {
				this.viewerNodeLeft =
				await partitionHeadsProductSchemaLeft.instantiate({
					rootLocalId : app.viewer.globalLocalId,
					appendType : 'insert',
					basketPart : [],
					basketUseDynamicTitleBinding : true,
					metadata : {
						id :           'left',
						customImages : [
							{
								enabled :   false,
								leftRight : 0,
								upDown :    0,
								resize :    1,
								rotate :    0,
								image :     null
							}
						]
					}
				});
				const ciDataLeft = this.viewerNodeLeft?.metadata?.customImages?.[ 0 ];
				if (ciDataLeft) {
					await (<ViewerGraphicsNS.Component> this.component_find('@:graphic-left')).updateValue(<any> ciDataLeft);
				}
				this.viewerNodeLeft.setName(this.viewerNodeLeft.product.name + ' ' + trs.left[ app.currentLanguage ]);
				if (GLE.component_find('@@@').component_isDisabled) {
					await GLE.component_find('@@@').component_enable();
				}
			}
			if (hasRight) {
				this.viewerNodeRight =
				await partitionHeadsProductSchemaRight.instantiate({
					rootLocalId : app.viewer.globalLocalId,
					appendType : 'insert',
					basketPart : [],
					basketUseDynamicTitleBinding : true,
					metadata : {
						id :           'right',
						customImages : [
							{
								enabled :   false,
								leftRight : 0,
								upDown :    0,
								resize :    1,
								rotate :    0,
								image :     null
							}
						]
					}
				});
				const ciDataRight = this.viewerNodeRight?.metadata?.customImages?.[ 0 ];
				if (ciDataRight) {
					await (<ViewerGraphicsNS.Component> this.component_find('@:graphic-right')).updateValue(<any> ciDataRight);
				}
				this.viewerNodeRight.setName(this.viewerNodeRight.product.name + ' ' + trs.right[ app.currentLanguage ]);
				if (GRE.component_find('@@@').component_isDisabled) {
					await GRE.component_find('@@@').component_enable();
				}
			}
			if(product.id === 'business'){
				await this.changeBackgroundColorNumberBusiness();
			}
		// } 
		// else {
		// 	this.partitionsSpace = 'top';
		// 	const partitionHeadsProductSchema = this.plannerCategory.products.find(x => x.SKU ===
		// 		`@partitionsHead-${ product.id }`);
		// 	if (!partitionHeadsProductSchema) {
		// 		this.component_throwLibraryError('');
		// 	}
		// 	this.viewerNodeLeft =
		// 		await partitionHeadsProductSchema.instantiate({
		// 			rootLocalId : app.viewer.globalLocalId,
		// 			appendType : 'insert',
		// 			basketPart : [],
		// 			basketUseDynamicTitleBinding : false,
		// 			metadata : {
		// 				id :           'left'
		// 			}
		// 	});
			// this.viewerNodeLeft.setName(this.viewerNodeLeft.product.name + ' ' + trs.left[ app.currentLanguage ]);
		}
		await this.update();
		const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
		if (!inputBool) {
			throw STD.errors.user('Missing input bool in content');
		}
		if (!inputBool.value) {
			await inputBool.updateValue(true);
		}
		// const GLE = <InputBool.Component> this.component_find('@:graphic-left:header.enable');
		// const GRE = <InputBool.Component> this.component_find('@:graphic-right:header.enable');
		// if(product.id === 'confort' || product.id === 'prestige'){
		// 	await GLE.component_find('@@@').component_disable();
		// 	await GRE.component_find('@@@').component_disable();
		// }else{
		// }
	};

	async update() {
		// update nodes matrices
		if (!this.viewerNodeLeft && !this.viewerNodeRight) {
			return;
		}
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available!');
		}
		if (product.id === 'confort' || product.id === 'prestige') {
			return;
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No current product available!');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			return;
		}
		if (product.id === 'siae') {
			await this.updateDisclaimerSIAE();
		}
		if (this.isPartitionsHeads) {
			const batch = [];
			if(this.viewerNodeLeft){
				batch.push({
					localId : this.viewerNodeLeft.localId,
					matrix :  this.computeMatrix('left')
				})
			}
			if(this.viewerNodeRight){
				batch.push({
					localId : this.viewerNodeRight.localId,
					matrix :  this.computeMatrix('right')
				})
			}
			await app.viewer.batch([
				[
					'setProductNodesInstancesMatrices', batch
				]
			]);
		}
	};

	isEqual(tableau1 : ViewerComponent.TMatrix , tableau2 : ViewerComponent.TMatrix ) {
		if (tableau1.length !== tableau2.length) return false;

		return tableau1.every((value, index) => value === tableau2[index]);
	}

	async updateOrRemove(){
		if(app.isReloading){
			await this.update();
			return;
		}
		const trs = {
			left :  <Record<string, string>> {
				en : 'left',
				fr : 'gauche'
			},
			right : <Record<string, string>> {
				en : 'right',
				fr : 'droite'
			}
		};
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available!');
		}
		if(product.id === 'confort' || product.id === 'prestige'){
			return;
		}
		if (product.id === 'siae') {
			await this.updateDisclaimerSIAE();
		}
		// if(product.id === 'confort' || product.id === 'prestige'){
		// 	await this.update();
		// 	return;
		// }
		const layout = product.getPart(['layout']);
		if(layout && layout.currentOption && layout.currentOption.id === 'shape-no-wall'){
			let check = false;
			if(this.isPartitionsHeads){
				check = true;
			}
			await this.remove();
			this.isPartitionsHeads = check;
			if(this.isPartitionsHeads){
				this.computeMatricesAndUpdateInfos();
			}
			return;
		}
		if(this.isPartitionsHeads){
			const matrix0 = ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0);
			const matrixLeft = this.computeMatrix('left');
			const matrixRight = this.computeMatrix('right');
			if(this.isEqual(matrixLeft, matrix0)){
				if(this.viewerNodeLeft){
					const GLE = <InputBool.Component> this.component_find('@:graphic-left:header.enable');
					if (GLE.value) {
						await GLE.updateValue(false);
					}
					if (!GLE.component_find('@@@').component_isDisabled) {
						await GLE.component_find('@@@').component_disable();
					}
					await this.viewerNodeLeft.delete();
					this.viewerNodeLeft = null;
				}
				if(!this.viewerNodeRight){
					const GLE = <InputBool.Component> this.component_find('@:graphic-right:header.enable');
					if (GLE.component_find('@@@').component_isDisabled) {
						await GLE.component_find('@@@').component_enable();
					}
					const partitionHeadsProductSchemaRight = this.plannerCategory.products.find(x => x.SKU ===
						`@partitionsHead-${ product.id }Right`);
					if (!partitionHeadsProductSchemaRight) {
						this.component_throwLibraryError('');
					}
					this.viewerNodeRight =
						await partitionHeadsProductSchemaRight.instantiate({
							rootLocalId : app.viewer.globalLocalId,
							appendType : 'insert',
							basketPart : [],
							basketUseDynamicTitleBinding : true,
							metadata : {
								id :           'right',
								customImages : [
									{
										enabled :   false,
										leftRight : 0,
										upDown :    0,
										resize :    1,
										rotate :    0,
										image :     null
									}
								]
							}
						});
						const ciDataRight = this.viewerNodeRight?.metadata?.customImages?.[ 0 ];
						if (ciDataRight) {
							await (<ViewerGraphicsNS.Component> this.component_find('@:graphic-right')).updateValue(<any> ciDataRight);
						}
						this.viewerNodeRight.setName(this.viewerNodeRight.product.name + ' ' + trs.right[ app.currentLanguage ]);
				}
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNodeRight.localId,
							matrix :  matrixRight
						}
					]
					]
				]);
			}else if(this.isEqual(matrixRight, matrix0)){
				if(this.viewerNodeRight){
					const GLE = <InputBool.Component> this.component_find('@:graphic-right:header.enable');
					if (GLE.value) {
						await GLE.updateValue(false);
					}
					if (!GLE.component_find('@@@').component_isDisabled) {
						await GLE.component_find('@@@').component_disable();
					}
					await this.viewerNodeRight.delete();
					this.viewerNodeRight = null;
				}
				if(!this.viewerNodeLeft){
					const GLE = <InputBool.Component> this.component_find('@:graphic-left:header.enable');
					if (GLE.component_find('@@@').component_isDisabled) {
						await GLE.component_find('@@@').component_enable();
					}
					const partitionHeadsProductSchemaLeft = this.plannerCategory.products.find(x => x.SKU ===
						`@partitionsHead-${ product.id }Left`);
					if (!partitionHeadsProductSchemaLeft) {
						this.component_throwLibraryError('');
					}
					this.viewerNodeLeft =
						await partitionHeadsProductSchemaLeft.instantiate({
							rootLocalId : app.viewer.globalLocalId,
							appendType : 'insert',
							basketPart : [],
							basketUseDynamicTitleBinding : true,
							metadata : {
								id :           'left',
								customImages : [
									{
										enabled :   false,
										leftRight : 0,
										upDown :    0,
										resize :    1,
										rotate :    0,
										image :     null
									}
								]
							}
						});
					const ciDataLeft = this.viewerNodeLeft?.metadata?.customImages?.[ 0 ];
					if (ciDataLeft) {
						await (<ViewerGraphicsNS.Component> this.component_find('@:graphic-left')).updateValue(<any> ciDataLeft);
					}
					this.viewerNodeLeft.setName(this.viewerNodeLeft.product.name + ' ' + trs.left[ app.currentLanguage ]);
				}
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNodeLeft.localId,
							matrix :  matrixLeft
						}
					]
					]
				]);
			}else{
				if(!this.viewerNodeRight){
					const GLE = <InputBool.Component> this.component_find('@:graphic-right:header.enable');
					if (GLE.component_find('@@@').component_isDisabled) {
						await GLE.component_find('@@@').component_enable();
					}
					const partitionHeadsProductSchemaRight = this.plannerCategory.products.find(x => x.SKU ===
						`@partitionsHead-${ product.id }Right`);
					if (!partitionHeadsProductSchemaRight) {
						this.component_throwLibraryError('');
					}
					this.viewerNodeRight =
						await partitionHeadsProductSchemaRight.instantiate({
							rootLocalId : app.viewer.globalLocalId,
							appendType : 'insert',
							basketPart : [],
							basketUseDynamicTitleBinding : true,
							metadata : {
								id :           'right',
								customImages : [
									{
										enabled :   false,
										leftRight : 0,
										upDown :    0,
										resize :    1,
										rotate :    0,
										image :     null
									}
								]
							}
						});
						const ciDataRight = this.viewerNodeRight?.metadata?.customImages?.[ 0 ];
						if (ciDataRight) {
							await (<ViewerGraphicsNS.Component> this.component_find('@:graphic-right')).updateValue(<any> ciDataRight);
						}
						this.viewerNodeRight.setName(this.viewerNodeRight.product.name + ' ' + trs.right[ app.currentLanguage ]);
				}
				if(!this.viewerNodeLeft){
					const GLE = <InputBool.Component> this.component_find('@:graphic-left:header.enable');
					if (GLE.component_find('@@@').component_isDisabled) {
						await GLE.component_find('@@@').component_enable();
					}
					const partitionHeadsProductSchemaLeft = this.plannerCategory.products.find(x => x.SKU ===
						`@partitionsHead-${ product.id }Left`);
					if (!partitionHeadsProductSchemaLeft) {
						this.component_throwLibraryError('');
					}
					this.viewerNodeLeft =
						await partitionHeadsProductSchemaLeft.instantiate({
							rootLocalId : app.viewer.globalLocalId,
							appendType : 'insert',
							basketPart : [],
							basketUseDynamicTitleBinding : true,
							metadata : {
								id :           'left',
								customImages : [
									{
										enabled :   false,
										leftRight : 0,
										upDown :    0,
										resize :    1,
										rotate :    0,
										image :     null
									}
								]
							}
						});
					const ciDataLeft = this.viewerNodeLeft?.metadata?.customImages?.[ 0 ];
					if (ciDataLeft) {
						await (<ViewerGraphicsNS.Component> this.component_find('@:graphic-left')).updateValue(<any> ciDataLeft);
					}
					this.viewerNodeLeft.setName(this.viewerNodeLeft.product.name + ' ' + trs.left[ app.currentLanguage ]);
				}
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNodeLeft.localId,
							matrix :  this.computeMatrix('left')
						},
						{
							localId : this.viewerNodeRight.localId,
							matrix :  this.computeMatrix('right')
						}
					]
					]
				]);
			}
		}

	};

	async remove() {
		if (!this.isPartitionsHeads) {
			return;
		}
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		if (!app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		if (this.viewerNodeLeft) {
			const GLE = <InputBool.Component> this.component_find('@:graphic-left:header.enable');
			if (GLE.value) {
				await GLE.updateValue(false);
			}
			if (!GLE.component_find('@@@').component_isDisabled) {
				await GLE.component_find('@@@').component_disable();
			}
			this.component_find('@:graphic-left');
			await this.viewerNodeLeft.delete();
			this.viewerNodeLeft = null;
		}
		if (this.viewerNodeRight) {
			const GRE = <InputBool.Component> this.component_find('@:graphic-right:header.enable');
			if (GRE.value) {
				await GRE.updateValue(false);
			}
			if (!GRE.component_find('@@@').component_isDisabled) {
				await GRE.component_find('@@@').component_disable();
			}
			await this.viewerNodeRight.delete();
			this.viewerNodeRight = null;
		}
		this.partitionsPosition = null;
		this.partitionsWidth = null;
		this.isPartitionsHeads = false;
	};

	async onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		if (ev.details.isDefaultValue) {
			return;
		}
		if (!app.basket || !app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		await app.transaction(async () => {
			if (ev.details.newValue) {
				if (!this.isPartitionsHeads) {
					await this.insert();
					await (<StandingPlinth.Component> app.component_find('K.standing-plinth')).update();
					const standINGObjectPositiningDynamicSets = <StandingObjectsPositioningDynamicsSetsNS.Component> app.component_findMaybe
					('@standing-objectsPositioningDynamicsSets');
					if(standINGObjectPositiningDynamicSets){
						await standINGObjectPositiningDynamicSets.refreshTvPositions();
					}
				}
			} else {
				if (this.isPartitionsHeads) {
					await this.remove();
					await (<StandingPlinth.Component> app.component_find('K.standing-plinth')).update();
					const standINGObjectPositiningDynamicSets = <StandingObjectsPositioningDynamicsSetsNS.Component> app.component_findMaybe
					('@standing-objectsPositioningDynamicsSets');
					if(standINGObjectPositiningDynamicSets){
						await standINGObjectPositiningDynamicSets.refreshTvPositions();
					}
				}
			}
			if (app.hasThisModuleUsed('viewer-planner-walls-editor')) {
				await (<PlannerWallsEditorNS.Component> app.component_find('@modules:panel.viewer-planner-walls-editor.content')).updateSize();
			}
			const storageMod = <StandingStorage.Component> app.modules.used.find(x => x.id === 'standing-storage')?.component;
			if (storageMod && storageMod.hasStorage()) {
				// await (<any> storageMod).update();
				// await (<any> storageMod).updateBanner();
				await (<any> storageMod).updateForPartitionsHeads();
			}
			await app.basketUpdate(ev);
		});
	};

	override async component_initialize() {
		const field = this.component_find('@:field:content');
		await field.component_instantiateOuterChild({
			type :          'input-bool',
			isSlot :        false,
			declaredSlot :  null,
			id :            'options',
			slot :          null,
			tree :          this.component_tree,
			parentNode :    null,
			configuration : <InputBool.Configuration> {
				type :            'yesno',
				defaultValue :    true,
				'@translations' : {
					checked :   {
						'en' : 'Yes',
						'fr' : 'Oui'
					},
					unchecked : {
						'en' : 'No',
						'fr' : 'Non'
					}
				}
			}
		});
		await super.component_initialize();
	};

	getConfiguratorMenu(side : 'left' | 'right' | 'unknown', ...others : any[]) {
		if (side === 'left') {
			return this.component_find('@:graphic-left');
		} else if (side === 'right') {
			return this.component_find('@:graphic-right');
		} else {
			void others;
		}
		return this;
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
		if (!app.viewer.planner) {
			this.component_throwUserError('');
		}
		const partitionsHeadsComponent = this.components;
		const customImagesExtensions = {
			'partitionsHead-ALeft' :  {
				configuratorGet : CM.PropertyOperation.CallOperation.create({
					type :          'call',
					componentPath : this.component_getPath(),
					propertyPath :  'getConfiguratorMenu',
					parameters :    [ 'left' ]
				}),
				customImages :    [
					{
						id :       'customImg',
						title :    { en : 'Add logo', fr : 'Ajouter un logo' },
						width :    .5,
						height :   .35,
						mesh :     '3D_configurateur 6x6 U.001',
						material : {
							name :          'custom_logo_cote',
							configuration : {
								enabled :  'custom_logo_cote',
								disabled : 'off'
							}
						},
						pricingInfo :   {
											pricing : <BasketNS.Pricing.FinalPricing.ISerialized> {
												type :  'final',
												price : {
													exclTax : 95
												}
											},
						},
						volumeComputation : {
							boundTo :          'unit',
							roundingStrategy : 'none'
						}
					}
				]
			},
			'partitionsHead-ARight' : {
				configuratorGet : CM.PropertyOperation.CallOperation.create({
					type :          'call',
					componentPath : this.component_getPath(),
					propertyPath :  'getConfiguratorMenu',
					parameters :    [ 'right' ]
				}),
				customImages :    [
					{
						id :       'customImg',
						title :    { en : 'Add logo', fr : 'Ajouter un logo' },
						width :    .5,
						height :   .35,
						mesh :     '3D_configurateur 6x6 U.073',
						material : {
							name :          'custom_logo_cote',
							configuration : {
								enabled :  'custom_logo_cote',
								disabled : 'off'
							}
						},
						pricingInfo :   {
							pricing : <BasketNS.Pricing.FinalPricing.ISerialized> {
								type :  'final',
								price : {
									exclTax : 95
								}
							},
						},
						volumeComputation : {
							boundTo :          'unit',
							roundingStrategy : 'none'
						}
					}
				]
			},
			'partitionsHead-CLeft' :  {
				configuratorGet : CM.PropertyOperation.CallOperation.create({
					type :          'call',
					componentPath : this.component_getPath(),
					propertyPath :  'getConfiguratorMenu',
					parameters :    [ 'left' ]
				}),
				customImages :    [
					{
						id :       'customImg',
						title :    { en : 'Add logo', fr : 'Ajouter un logo' },
						width :    .8019,
						height :   .502,
						mesh :     'TETE DE CLOISON DROITE.011',
						material : {
							name :          'teteCloison_visuel',
							configuration : {
								enabled :  'teteCloison_visuel',
								disabled : 'off'
							}
						}
					}
				]
			},
			'partitionsHead-CRight' : {
				configuratorGet : CM.PropertyOperation.CallOperation.create({
					type :          'call',
					componentPath : this.component_getPath(),
					propertyPath :  'getConfiguratorMenu',
					parameters :    [ 'right' ]
				}),
				customImages :    [
					{
						id :       'customImg',
						title :    { en : 'Add logo', fr : 'Ajouter un logo' },
						width :    .8019,
						height :   .502,
						mesh :     'TETE DE CLOISON DROITE.001',
						material : {
							name :          'teteCloison_visuel',
							configuration : {
								enabled :  'teteCloison_visuel',
								disabled : 'off'
							}
						}
					}
				]
			}
		};
		const viewerSKUMappingToInternalMapping : Record<string, string> = {
			'@partitionsHead-businessLeft' :  'partitionsHead-ALeft',
			'@partitionsHead-businessRight' : 'partitionsHead-ARight',
			'@partitionsHead-siaeLeft' :      'partitionsHead-CLeft',
			'@partitionsHead-siaeRight' :     'partitionsHead-CRight',
		};
		(<STD.object.SetWritable<this, 'plannerCategory'>> this).plannerCategory = app.viewer.createCategory({
			name :        'partitionsHeads',
			menuActions : {
				edit :      true,
				delete :    false,
				rotate :    false,
				duplicate : false
			},
			products :    partitionsHeadsComponent.reduce<ViewerComponent.Product.IDescriptor[]>((a, c) => {
				let addSKU = '';
				if (c.SKU.endsWith('Left')) {
					addSKU = 'Left';
				} else if (c.SKU.endsWith('Right')) {
					addSKU = 'Right';
				}
				for (const productSKU of c.products) {
					const dynamicSKU = `@partitionsHead-${ productSKU }${ addSKU }`;
					const realSKU = viewerSKUMappingToInternalMapping[ dynamicSKU ];
					if (!realSKU) {
						this.component_throwLibraryError('');
					}
					app.viewer.productsExtensionById[ dynamicSKU ] = (<any> customImagesExtensions)[ realSKU ];
					a.push({
						SKU :   dynamicSKU,
						name :  c.translations[ '@name' ]?.[ app.currentLanguage ],
						nodes : [
							{
								SKU :                         <string> c.viewerComponentSKU,
								projectCode :                 <string> c.viewerProjectCode,
								localId :                     'global',
								parentLocalId :               'root',
								snappable :                   false,
								fixedPositionSetIds :         null,
								draggable :                   false,
								doNotListAsProductComponent : true,
								tracked :                     true,
								matrix :                      app.viewer.mtx(
									[ 0, 0, 0 ],
									[ 0, 0, 0 ],
									0
								)
							}
						]
					});
				}
				return a;
			}, [])
		});
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingPartitionsHeadsComponentConfiguration
	)
	{
		configuration[ '@innerConfigurations' ] = {
			field :           {
				'@innerConfigurations' : {
					header : {
						'@innerConfigurations' : {
							label : {
								'@translations' : {
									text : configuration.text
								}
							}
						}
					}
				}
			},
			tutoContainer :   {
				'@innerConfigurations' : {
					imageInformation : <Image.Configuration> {
						URL : (app.clientAppParameters.app.assetsPath +
							'icon-infos.png').replace('CH1U0ZGKSI', 'E3GC4QDIZW').
									replace('XUJG0A2TF5', 'STAODAZNIS').
									replace('sam1_12345', 'STAODAZNIS')
					}
				}
			},
			'graphic-left' :  <Partial<ViewerGraphicsNS.Configuration>> {
				forceBackgroundColor :   configuration.forceBackgroundColor,
				'@innerConfigurations' : {
					header : {
						'@innerConfigurations' : {
							title : {
								'@translations' : {
									text : configuration.textLeft
								}
							}
						}
					}
				}
			},
			'graphic-right' : <Partial<ViewerGraphicsNS.Configuration>> {
				forceBackgroundColor :   configuration.forceBackgroundColor,
				'@innerConfigurations' : {
					header : {
						'@innerConfigurations' : {
							title : {
								'@translations' : {
									text : configuration.textRight
								}
							}
						}
					}
				}
			}
		};
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory();
	};
};
export namespace NS {
	export const Component = StandingPartitionsHeadsComponent;
	export type Component = StandingPartitionsHeadsComponent;
	export type Configuration = IStandingPartitionsHeadsComponentConfiguration;
}
import manifestXMLSource                   from './StandingPartitionsHeads.xml';
import './StandingPartitionsHeads.scss';

CM.declare({
	id :       'standing-partitionsHeads',
	type :     StandingPartitionsHeadsComponent,
	manifest : manifestXMLSource
});
